// Viti Vinci — quick-buy on product cards.
// Click a [data-quick-buy] button → POST to /cart/add.js → flip icon to ✓
// → dispatch Horizon's `cart:update` event so the cart drawer/count refresh.

document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-quick-buy]');
  if (!btn) return;

  event.preventDefault();
  event.stopPropagation();

  // Already in flight or already added
  if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) {
    return;
  }

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('is-loading');
  btn.setAttribute('aria-busy', 'true');

  try {
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (!addRes.ok) {
      const err = await addRes.json().catch(() => ({}));
      throw new Error(err.description || 'Add to cart failed');
    }

    // Pull the updated cart so other components can refresh
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    btn.classList.add('is-added');
    btn.setAttribute('aria-pressed', 'true');

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        detail: {
          resource: cart,
          sourceId: 'quick-buy',
          source: 'quick-buy',
          variantId,
          itemCount: cart.item_count,
        },
      })
    );
  } catch (err) {
    console.error('[quick-buy]', err);
    btn.classList.remove('is-added');
    btn.removeAttribute('aria-pressed');
    document.dispatchEvent(
      new CustomEvent('cart:error', {
        detail: { source: 'quick-buy', message: err.message },
      })
    );
  } finally {
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
  }
});
